import { render, staticRenderFns } from "./GettingStarted.vue?vue&type=template&id=6fe0a751"
import script from "./GettingStarted.vue?vue&type=script&lang=ts"
export * from "./GettingStarted.vue?vue&type=script&lang=ts"
import style0 from "./GettingStarted.vue?vue&type=style&index=0&id=6fe0a751&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports